/**
 * P-03/A1 (D-31) — the closed payment-terms list of a service contract, an
 * hour bank and a לל"ח (the server accepts a NEW value only from it).
 */
export const PAYMENT_TERMS = [
  'by_10', 'by_15', 'by_20', 'by_25',
  'net', 'net_30', 'net_60', 'net_90',
] as const;

/**
 * The options of a terms <select>: the list, plus the row's current value when
 * it is a legacy code with no certain mapping (shown, never offered for new).
 */
export function paymentTermOptions(current?: string | null): string[] {
  const list: string[] = [...PAYMENT_TERMS];
  if (current && !list.includes(current)) list.push(current);
  return list;
}

/**
 * QA-R1 #16 — a legacy code (not on the list) is shown as a DISABLED option:
 * it can stay as it is (an unchanged value saves), never be picked anew.
 */
export function isLegacyPaymentTerm(code: string): boolean {
  return !(PAYMENT_TERMS as readonly string[]).includes(code);
}
